<div class="modal-body">
    <button class="btn modal-close" (click)="activeModal.dismiss()">
        <i class="icon icon-x"></i>
    </button>
    <p class="text-center">
        <img class="free-practice-intro-image shadow-9dp" src="/src/assets/image/free-practice-intro.jpg">
    </p>
</div>
